var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_55810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 7.33333H9.16667V0.666667C9.16667 0.489856 9.09643 0.320286 8.97141 0.195262C8.84638 0.0702379 8.67681 0 8.5 0V0C8.32319 0 8.15362 0.0702379 8.0286 0.195262C7.90357 0.320286 7.83333 0.489856 7.83333 0.666667V7.33333H1.16667C0.989856 7.33333 0.820286 7.40357 0.695262 7.5286C0.570238 7.65362 0.5 7.82319 0.5 8H0.5C0.5 8.17681 0.570238 8.34638 0.695262 8.47141C0.820286 8.59643 0.989856 8.66667 1.16667 8.66667H7.83333V15.3333C7.83333 15.5101 7.90357 15.6797 8.0286 15.8047C8.15362 15.9298 8.32319 16 8.5 16C8.67681 16 8.84638 15.9298 8.97141 15.8047C9.09643 15.6797 9.16667 15.5101 9.16667 15.3333V8.66667H15.8333C16.0101 8.66667 16.1797 8.59643 16.3047 8.47141C16.4298 8.34638 16.5 8.17681 16.5 8C16.5 7.82319 16.4298 7.65362 16.3047 7.5286C16.1797 7.40357 16.0101 7.33333 15.8333 7.33333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_55810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.1bc1505b6df20ca6af68f7a66853ead2.svg";
export { ForwardRef as ReactComponent };